import { Component } from '@angular/core';

@Component({
  selector: 'app-termscondition',
  templateUrl: './termscondition.component.html',
  styleUrls: []
})
export class TermsconditionComponent {
  constructor() {
    window.scroll(0, 0);
  }
}
